import { render } from "./NewsEditor.vue?vue&type=template&id=d0b919ee&scoped=true"
import script from "./NewsEditor.vue?vue&type=script&lang=js"
export * from "./NewsEditor.vue?vue&type=script&lang=js"

import "./NewsEditor.vue?vue&type=style&index=0&id=d0b919ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b919ee"]])

export default __exports__